import {
  ChangeEmailAddressPayload,
  ChangePasswordPayload,
  DeleteAccountPayload,
  I18nAccountError,
  Mutation as accountMutations,
} from './account/account-resolver-overrides';
import {
  UpdateShareableProfileSettingsPayload,
  Mutation as visibilityMutations,
} from './visibility/visibility-resolver-overrides';
import {
  UnsubscribeApacSavedSearchByCodePayload,
  ResubscribeApacSavedSearchByCodePayload,
  Mutation as notificationsMutations,
} from './notifications/notifications-resolver-overrides';

const resolverOverrides = (_mockStore: any) => ({
  // Account:
  ChangeEmailAddressPayload,
  I18nAccountError,
  ChangePasswordPayload,
  DeleteAccountPayload,

  // Visibility:
  UpdateShareableProfileSettingsPayload,

  // Notifications:
  UnsubscribeApacSavedSearchByCodePayload,
  ResubscribeApacSavedSearchByCodePayload,

  Mutation: {
    ...accountMutations,
    ...visibilityMutations,
    ...notificationsMutations,
  },
});

export default resolverOverrides;
